import React from "react";
import { Link } from "react-router-dom";
import "./publicTicketPortalPage.css";

/**
 * Portal público por empresa: /portal/{id} (id numérico da empresa no sistema).
 */
const PublicPortalEntryPage = () => {
  return (
    <div className="public-portal-root public-portal-entry">
      <div className="public-portal-entry-card">
        <h1>Portal de tickets</h1>
        <p>
          O acesso é feito pelo link da sua organização, no formato{" "}
          <code>/portal/<em>id</em></code> (número da empresa).
        </p>
        <p className="public-portal-entry-hint">
          Quem administra o sistema vê o link pronto em{" "}
          <strong>Empresas</strong>: coluna <strong>Portal público</strong> ou,
          ao editar a empresa, o bloco <strong>Link público</strong> com botão
          de copiar.
        </p>
        <p>
          <Link to="/login">Entrar no painel</Link>
        </p>
      </div>
    </div>
  );
};

export default PublicPortalEntryPage;
